// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Caml_obj = require("@rescript/std/lib/js/caml_obj.js");
var User_Api = require("./User_Api.bs.js");
var Util_Opt = require("../util/Util_Opt.bs.js");
var Type_Club = require("../club/Type_Club.bs.js");
var User_Type = require("./User_Type.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Belt_Result = require("@rescript/std/lib/js/belt_Result.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Common = require("../type/Type_Common.bs.js");
var Type_String = require("../type/Type_String.bs.js");
var Util_Result = require("../util/Util_Result.bs.js");
var User_Context = require("./User_Context.bs.js");
var User_Storage = require("./User_Storage.bs.js");
var User_Observable = require("./User_Observable.bs.js");

function internal_getToken(get, token) {
  return Util_Opt.getWithDefaultLazy(Belt_Option.flatMap(Belt_Option.map((token == null) ? undefined : Caml_option.some(token), Type_String.User.Token.make), (function (token) {
                    if (typeof token === "number") {
                      return ;
                    } else {
                      return Caml_option.some(token);
                    }
                  })), (function (param) {
                return Belt_Option.flatMap(Util_Result.toOption(Curry._1(get, undefined)), User_Type.getToken);
              }));
}

function getToken(param) {
  return internal_getToken(User_Storage.get, param);
}

function getTokenFromStorage(param) {
  return internal_getToken(User_Storage.get, null);
}

function parseResponse(response) {
  if (response.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: response._0
          };
  }
  var tmp = response._0;
  if (typeof tmp === "number") {
    if (tmp === /* TooManyRequest */3) {
      return {
              TAG: /* Error */1,
              _0: /* TooManyRequest */2
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: /* ServerError */3
            };
    }
  } else if (tmp.TAG === /* BadRequest */0) {
    return {
            TAG: /* Error */1,
            _0: /* BadRequest */1
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: /* ServerError */3
          };
  }
}

var persistProgressionAvailability = {
  contents: "server"
};

function setPersistAvailabilityToLocalOnly(param) {
  persistProgressionAvailability.contents = "localOnly";
  setTimeout((function (param) {
          persistProgressionAvailability.contents = "server";
        }), 60000);
}

function setProgression(programId, timeInSeconds, durationInSeconds, persistMethod) {
  var persist = Belt_Option.getWithDefault((persistMethod == null) ? undefined : Caml_option.some(persistMethod), {
        method: "localOnly",
        token: null
      });
  var timeInSeconds$1 = timeInSeconds | 0;
  User_Storage.setProgression(programId, timeInSeconds$1, durationInSeconds);
  var user = Curry._1(User_Storage.get, undefined);
  var user$1 = Util_Result.toOption(user);
  var currentUser = user$1 !== undefined ? user$1 : Caml_option.some(User_Type.make(undefined, undefined, undefined, Type_String.User.Token.disconnected));
  var progression = Type_Common.Progression.makeFromTimeAndDuration(timeInSeconds$1, durationInSeconds);
  if (progression !== undefined) {
    var progression$1 = Caml_option.valFromOption(progression);
    var user$2 = User_Type.setTimeProgression(programId, progression$1, currentUser);
    if (user$2 !== undefined) {
      Curry._1(User_Storage.save, Caml_option.valFromOption(user$2));
      Curry._2(User_Observable.Progression.notify, programId, progression$1);
    } else {
      Curry._1(User_Storage.save, User_Type.disconnected);
    }
  }
  var ensuredToken = internal_getToken(User_Storage.get, persist.token);
  var match = persistProgressionAvailability.contents;
  if (match === "server" && persist.method === "server" && ensuredToken !== undefined && typeof ensuredToken !== "number") {
    return User_Api.LastVieweds.set(User_Context.getEnv(undefined), ensuredToken, programId, timeInSeconds$1).then(parseResponse).then(function (result) {
                if (result.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: null
                        };
                } else if (result._0 !== 2) {
                  return {
                          TAG: /* Error */1,
                          _0: /* ServerError */3
                        };
                } else {
                  setPersistAvailabilityToLocalOnly(undefined);
                  return {
                          TAG: /* Error */1,
                          _0: /* TooManyRequest */2
                        };
                }
              });
  }
  if (persist.method === "localOnly") {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: null
              });
  } else if (ensuredToken !== undefined && typeof ensuredToken !== "number") {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* TooManyRequest */2
              });
  } else {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: /* NoToken */0
              });
  }
}

var getVideoProgressionById = User_Storage.getProgression;

function internal_getProgressionByIdAsync(getToken, fromLocal, fromServer) {
  return function (programId, language, source) {
    var source$1 = Belt_Option.getWithDefault((source == null) ? undefined : Caml_option.some(source), {
          method: "server",
          token: null
        });
    var localValue = Curry._1(fromLocal, programId);
    var ensuredToken = Curry._1(getToken, source$1.token);
    if (source$1.method === "localOnly") {
      return localValue;
    } else if (ensuredToken !== undefined && typeof ensuredToken !== "number") {
      return Promise.all([
                    localValue,
                    Curry._3(fromServer, programId, language, ensuredToken)
                  ]).then(function (param) {
                  var server = param[1];
                  var local = param[0];
                  if (local.TAG !== /* Ok */0) {
                    return server;
                  }
                  var localProgression = local._0;
                  if (localProgression === undefined) {
                    if (server.TAG === /* Ok */0) {
                      if (server._0 !== undefined) {
                        return server;
                      } else {
                        return {
                                TAG: /* Ok */0,
                                _0: undefined
                              };
                      }
                    } else {
                      return local;
                    }
                  }
                  var localProgression$1 = Caml_option.valFromOption(localProgression);
                  if (server.TAG !== /* Ok */0) {
                    return local;
                  }
                  var serverProgression = server._0;
                  if (serverProgression === undefined) {
                    return local;
                  }
                  var serverProgression$1 = Caml_option.valFromOption(serverProgression);
                  if (Caml_obj.greaterequal(localProgression$1, serverProgression$1)) {
                    return {
                            TAG: /* Ok */0,
                            _0: Caml_option.some(localProgression$1)
                          };
                  } else {
                    return {
                            TAG: /* Ok */0,
                            _0: Caml_option.some(serverProgression$1)
                          };
                  }
                });
    } else {
      return Promise.resolve({
                  TAG: /* Error */1,
                  _0: /* NoToken */0
                });
    }
  };
}

function fromServer(programId, language, token) {
  var programId$1 = Curry._1(Type_String.Program.Id.make, programId);
  return User_Api.LastVieweds.getById("prod", token, language, programId$1).then(parseResponse).then(function (__x) {
              return Belt_Result.map(__x, (function (__x) {
                            return Belt_Option.flatMap(__x, (function (param) {
                                          return Belt_Option.flatMap(Caml_option.nullable_to_opt(param.lastviewed), (function (param) {
                                                        return Caml_option.nullable_to_opt(param.timecode);
                                                      }));
                                        }));
                          }));
            });
}

function fromLocal(programId) {
  return Promise.resolve({
              TAG: /* Ok */0,
              _0: getVideoProgressionById(programId)
            });
}

var getProgressionByIdAsync = internal_getProgressionByIdAsync(getToken, fromLocal, fromServer);

async function fetchMe(token) {
  var env = User_Context.getEnv(undefined);
  var controller = new AbortController();
  if (token !== undefined) {
    return await User_Api.Me.get(env, controller.signal, token);
  }
  
}

async function getUserInfo() {
  var userToken = internal_getToken(User_Storage.get, null);
  var user = await fetchMe(userToken);
  var isConnected = userToken !== undefined && !(typeof userToken === "number" || userToken.TAG === /* Anonymous */0) ? true : false;
  var ageVerificationToken = user !== undefined && user.TAG === /* Ok */0 ? Belt_Option.flatMap(Belt_Array.get(Type_Club.$$Response.getData(user._0), 0), Type_Club.User.getAgeVerificationToken) : undefined;
  return {
          isConnected: isConnected,
          ageVerificationToken: ageVerificationToken
        };
}

function onLogin(callback) {
  var id = Curry._1(User_Observable.UserStatus.subscribe, (function (userStatus) {
          if (userStatus >= 2) {
            return ;
          } else {
            return Curry._1(callback, undefined);
          }
        }));
  return {
          unsubscribe: (function (param) {
              Curry._1(User_Observable.UserStatus.unsubscribe, id);
            })
        };
}

function onLogout(callback) {
  var id = Curry._1(User_Observable.UserStatus.subscribe, (function (userStatus) {
          if (userStatus >= 2) {
            return Curry._1(callback, undefined);
          }
          
        }));
  return {
          unsubscribe: (function (param) {
              Curry._1(User_Observable.UserStatus.unsubscribe, id);
            })
        };
}

exports.internal_getToken = internal_getToken;
exports.getToken = getToken;
exports.getTokenFromStorage = getTokenFromStorage;
exports.parseResponse = parseResponse;
exports.persistProgressionAvailability = persistProgressionAvailability;
exports.setPersistAvailabilityToLocalOnly = setPersistAvailabilityToLocalOnly;
exports.setProgression = setProgression;
exports.getVideoProgressionById = getVideoProgressionById;
exports.internal_getProgressionByIdAsync = internal_getProgressionByIdAsync;
exports.getProgressionByIdAsync = getProgressionByIdAsync;
exports.fetchMe = fetchMe;
exports.getUserInfo = getUserInfo;
exports.onLogin = onLogin;
exports.onLogout = onLogout;
/* getProgressionByIdAsync Not a pure module */
